module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<table class="table table-hover">\r\n    <thead>\r\n    <tr>\r\n        <th>Start date</th>\r\n        <th>Stop date</th>\r\n        <th>Comment</th>\r\n    </tr>\r\n    </thead>\r\n    <tbody></tbody>\r\n</table>\r\n\r\n';
 if (!isReadOnly) { 
__p+='\r\n<button type="button" class="btn btn-primary btn-sm" id="e-new">New</button>\r\n<button type="button" class="btn btn-primary btn-sm" id="e-save">Add</button>\r\n\r\n<div id="edits" class="form-inline" style="margin-top: 10px;">\r\n    <div class="form-group">\r\n        <div class="col-sm-3 col-md-3">\r\n            <input class="form-control" type="text" id="e-start-date" placeholder="Start date"\r\n                   onkeypress="return false;">\r\n        </div>\r\n        <div class="col-sm-3 col-md-3">\r\n            <input class="form-control" type="text" id="e-stop-date" placeholder="Stop date"\r\n            onkeypress="return false;">\r\n        </div>\r\n        <div class="col-sm-6 col-md-6">\r\n            <textarea class="form-control" rows="3" cols="20" id="e-comment" placeholder="Comment"></textarea>\r\n        </div>\r\n    </div>\r\n</div>\r\n';
 } 
__p+='';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/medicals/exacerbations.html
// module id = 360
// module chunks = 0